"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldToastData = exports.EmeraldToastInputs = exports.DefaultContainerID = void 0;
/* eslint-disable @typescript-eslint/no-inferrable-types */
const toast_position_1 = require("./toast.position");
const toast_variance_1 = require("./toast.variance");
exports.DefaultContainerID = 'Main';
class EmeraldToastInputs {
    constructor() {
        this.id = `${Math.floor(Math.random() * 10000)}`;
        this.opened = false;
        this.title = '';
        this.containerId = `${Math.floor(Math.random() * 10000)}`;
        this.variance = toast_variance_1.EmeraldToastVariance.INFO;
        this.hasActionButton = false;
        this.primaryActionText = 'Ok';
        this.xPosition = toast_position_1.EmeraldToastXPosition.RIGHT;
        this.yPosition = toast_position_1.EmeraldToastYPosition.TOP;
        this.autoDismiss = false;
        this.autoDismissMilliseconds = 5000;
    }
}
exports.EmeraldToastInputs = EmeraldToastInputs;
class EmeraldToastData {
    constructor(title, message, variance = toast_variance_1.EmeraldToastVariance.INFO, yPosition = toast_position_1.EmeraldToastYPosition.TOP, xPosition = toast_position_1.EmeraldToastXPosition.RIGHT, autoDismiss = false, inlined = false, containerId = exports.DefaultContainerID) {
        this.title = title;
        this.message = message;
        this.variance = variance;
        this.yPosition = yPosition;
        this.xPosition = xPosition;
        this.autoDismiss = autoDismiss;
        this.inlined = inlined;
        this.containerId = containerId;
        this.hasActionButton = false;
        this.primaryActionText = 'Ok';
        this.autoDismissMilliseconds = 5000;
        this.toastId = `${Math.floor(Math.random() * 10000)}`;
    }
}
exports.EmeraldToastData = EmeraldToastData;
//# sourceMappingURL=toast.inputs.js.map